import { render } from "./doctorprofile-settings2.vue?vue&type=template&id=e1984356&scoped=true"
import script from "./doctorprofile-settings2.vue?vue&type=script&lang=js"
export * from "./doctorprofile-settings2.vue?vue&type=script&lang=js"

import "./doctorprofile-settings2.vue?vue&type=style&index=0&id=e1984356&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1984356"]])

export default __exports__